import { createSelector } from 'reselect';

export const getSavedFiltersAccesor = state => state.dashboard.savedFilters;

export const savedFiltersScreenSelector = screen =>
    createSelector(getSavedFiltersAccesor, savedFilters => savedFilters.screens[screen] || { presets: [], defaultPreset: null });
